import { useEffect } from "react";

export default function PaymentSuccess() {
    useEffect(() => {
        localStorage.removeItem("questionFeatures");
        localStorage.removeItem("formData2");
        localStorage.removeItem("form1Title");
        localStorage.removeItem("form1Description");
        localStorage.removeItem("form1Price");
        localStorage.removeItem("form1Photo");
        localStorage.removeItem("form1Question");
        localStorage.removeItem("form1Categories");
    }, []);

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "20px"
            }}
        >
            <h1>Payment Successful</h1>

            <p style={{ maxWidth: "400px", marginTop: "10px" }}>
                Your study has launched.
            </p>
            <button
                onClick={() => window.location.href = "/"}
                className="create-product"
                style={{ marginTop: "10px" }}
            >
                Go to Homepage
            </button>
        </div>
    );
}
